/**
 * Lot BA : version de l'appli ouverte (celle du bundle, écrite au build par Vite depuis apps/web/package.json),
 * comparée à celle du serveur pour proposer de rafraîchir quand une nouvelle version est en ligne.
 */
declare const __APP_VERSION__: string | undefined;

export const APP_VERSION: string = typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '0.0.0';
